import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LayoutContext } from './layout-context';
import { Mode } from './mode';

export const Layout = (props) => {
  const Component = props.component;
  const itemName = props.item;
  const {
    config, styles, change: changeLayout, isGridLayout,
  } = useContext(LayoutContext);

  const componentProps = { ...(_.result(config, itemName)), changeLayout };

  let className = '';
  if (!isGridLayout) {
    const { classes } = _.result(styles, itemName);
    className = _.result(classes, itemName);
  }

  return (
    <div
      className={`app-shell-${itemName} ${className}`}
      style={isGridLayout && (componentProps.mode === Mode.Hidden) ? { display: 'none' } : {}}
    >
      <Component {..._.defaults(componentProps, props)} />
    </div>
  );
};

Layout.propTypes = {
  component: PropTypes.elementType.isRequired,
  item: PropTypes.string.isRequired,
};
